import type { CommandAction } from '../../CommandPalette'
import { getSectionRequiredCapabilities } from '@emporion/config/sections'
import { canAccessSection } from '../../../utils/permissions'
import { buildNavigationCoreActions } from './navigationCoreActions'
import { buildNavigationShopActions } from './navigationShopActions'
import type { BuildCommandActionsContext } from './types'

const NAVIGATION_ACTION_SECTION_KEYS: Record<string, string> = {
  'nav-dashboard': 'dashboard',
  'nav-support-inbox': 'support-inbox',
  'nav-slider': 'slider',
  'nav-pages': 'pages',
  'nav-site-branding': 'site-branding',
  'nav-themes': 'themes',
  'nav-site-footer': 'site-footer',
  'nav-site-legal': 'site-legal',
  'nav-site-contact': 'site-contact',
  'nav-site-email-templates': 'site-email-templates',
  'nav-site-email-logs': 'site-email-logs',
  'nav-site-payments': 'site-payments',
  'nav-system-status': 'system-status',
  'nav-updates': 'updates',
  'nav-feature-flags': 'feature-flags',
  'nav-audit-logs': 'audit-logs',
  'nav-audit-trail': 'audit-trail',
  'nav-menu': 'menu',
  'nav-shop-products': 'shop-products',
  'nav-shop-categories': 'shop-categories',
  'nav-shop-orders': 'shop-orders',
  'nav-shop-customers': 'customers',
  'nav-shop-migrations': 'shop-migrations',
  'nav-shop-product-types': 'shop-product-types',
}

const PROFILE_ACTION_SECTION_KEYS: Record<string, string> = {
  'profile-contact': 'profile-contact',
  'profile-addresses': 'profile-addresses',
  'profile-smtp': 'profile-smtp',
  'profile-security': 'profile-security',
  'profile-sessions': 'profile-sessions',
  'profile-team': 'profile-team',
  'profile-danger': 'profile-danger',
}

export const buildNavigationCommandActions = (
  context: BuildCommandActionsContext,
  options?: { isCustomerOnly?: boolean },
): CommandAction[] => {
  const isCustomerOnly = options?.isCustomerOnly === true
  const userCapabilities = context.userCapabilities

  const actions = [
    ...buildNavigationCoreActions(context),
    ...buildNavigationShopActions(context),
  ]

  if (isCustomerOnly) {
    const allowedIds = new Set(['nav-dashboard', 'nav-support-inbox', 'nav-shop-orders'])
    return actions.filter((action) => allowedIds.has(action.id))
  }

  return actions.filter((action) => {
    const sectionKey = NAVIGATION_ACTION_SECTION_KEYS[action.id]
    if (!sectionKey) return true
    return canAccessSection(sectionKey, userCapabilities, (key: string) => getSectionRequiredCapabilities(key))
  })
}
